import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgButtonGoTop = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2 2V2C2 2 3.12874 2 5.94745 2L10.0525 2C12.8713 2 14 2 14 2V2",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-2-inside-1_6072_5497",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", { d: "M5.33317 7L7.99984 4.33333L10.6665 7" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.91896 5.58579C3.13791 6.36683 3.13791 7.63317 3.91896 8.41421C4.70001 9.19526 5.96634 9.19526 6.74738 8.41421L3.91896 5.58579ZM7.99984 4.33333L9.41405 2.91912C8.633 2.13807 7.36667 2.13807 6.58562 2.91912L7.99984 4.33333ZM9.25229 8.41421C10.0333 9.19526 11.2997 9.19526 12.0807 8.41421C12.8618 7.63317 12.8618 6.36683 12.0807 5.58579L9.25229 8.41421ZM6.74738 8.41421L9.41405 5.74755L6.58562 2.91912L3.91896 5.58579L6.74738 8.41421ZM6.58562 5.74755L9.25229 8.41421L12.0807 5.58579L9.41405 2.91912L6.58562 5.74755Z",
			fill: "currentColor",
			mask: "url(#path-2-inside-1_6072_5497)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 13C8 10.2 8 7.16667 8 6",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round"
		})
	]
});
export default SvgButtonGoTop;
